/* eslint-disable max-lines */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandler } from '../../helper/error_handler';
import { isErrorWithMessage } from '../../helper';
import NotificationApi from '../../apis/notifications';
import { NotificationReadUnreadParams } from '@params/redux/notification';
import { resettingNotificaitonLoader } from '../slices/notification';
import { RootState } from '../../redux/store';

export const fetchAllNotificaitonsThunk = createAsyncThunk(
    'notification/fetch',
    async (_, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await NotificationApi.fetchNotification(state.app.token);
            if (response?.success === 1) {
                return response?.notifications;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingNotificaitonLoader());
        }
    }
);

export const markReadUnreadNotificaitonThunk = createAsyncThunk(
    'notification/read-unread',
    async (data: NotificationReadUnreadParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await NotificationApi.markAsReadUnreadNotification(state.app.token, data);
            if (response?.success === 1) {
                return response?.notifications;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingNotificaitonLoader());
        }
    }
);